<div class="session-setup">
  <div class="loading-container">
    @if ($sessionState().step !== 'error') {
    <div class="spinner"></div>
    } @if (!$sessionState().error) {
    <h2>{{ getStepMessage() }}</h2>
    } @else {
    <p class="error">
      {{ $sessionState().error }}
      <button type="button" (click)="backToLogin()">Back to Login</button>
    </p>
    }
  </div>
</div>
